"use strict";

import Vue from 'vue'
import VueFilterNumber from '@/vue/filters/vue-filter-number'
import EventBus from '@/vue/events/event-bus'
import allBetMixin from '@/vue/mixins/allBet'
Vue.component('odd1x2',{
  mixins: [allBetMixin],
  name:'odd1x2',
  template: `
      <span class="ratio" :style="{float:cssAttr['style1']}">
        <font :class="{ngve: isNegative, diff: isDiff}">
          <template v-if="event.od">
            <template v-if="event.od && event.od && event.od[team]">
                {{ parseFloat(event.od[team]).toFixed(2) }}
            </template>
            <template v-else>
              <span class="odd-oe" :class="{ ht: plyType != '1'}"></span>
            </template>
          </template>
          <template v-else>
              <span class="odd-oe" :class="{ ht: plyType != '1'}"></span>
            </template>
        </font>
        <span class="change-icon" v-if="isDiff" :class="{'icon-red': isDiff && isUp, 'icon-green': isDiff && !isUp}"></span>
      </span>
  `,
  props: {
    event: null,
    bmk: null,
    plyType: null,
    betType: null,
    type: null,
    team: null,
    uid:null,
    isAllBet:null,
    styleAttr:null,
  },
  watch: {
    'event': {
      handler(val, oldVal) {
        if(this.isDefinedOdds(val)) {
          this.classNegative(val.od[this.team])
          //check if immediate call
          if(oldVal && !this.refreshOdd){
            this.refreshOdd = false
            if(this.isDefinedOdds(oldVal)) {
              this.diffOddsUpDown(val.od[this.team], oldVal.od[this.team])
              this.diffOdds(val.od[this.team], oldVal.od[this.team])
            }
            this.checkOdds()
          } else if (this.refreshOdd) {
            this.refreshOdd = false
            this.isDiff = false
          } else if (!oldVal) { //when not same template
            this.refreshOdd = true
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isNegative: false,
      isDiff: false,
      matchId: null,
      refreshOdd: false,
      isUp: false,
    }
  },
  methods: {
    cssAttr(){
      if(this.styleAttr){
        return this.styleAttr
      }
      return 'inherit'
    },
    // onClickOdd () {
    //   // this.$store.commit('ODD_SELECTED', true)
    //   // var betForm = {
    //   //   title: this.$store.getters.selectedBettype.sprtTitleLang ,
    //   //   league: this.event.lgecapt,
    //   //   plyType: this.plyType,
    //   //   betType: this.betType,
    //   //   ta: this.event.tacapt,
    //   //   tb: this.event.tbcapt,
    //   //   odd: this.event.od[this.plyType][this.betType]['odds' + this.team],
    //   //   eventObj: this.event,
    //   // }

    //   // if(this.team == 'd') { //is bet draw
    //   //   betForm.tbet =  this.$store.getters.sportTableLang.table['SPORT_TABLE.DRAW']
    //   // } else if (this.team == 'h') { //is bet team a
    //   //   betForm.tbet =  this.event.tacapt
    //   // } else { //is bet team b
    //   //   betForm.tbet =  this.event.tbcapt
    //   // }
    //   // if(this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
    //   //   var market = this.$store.getters.market.inPlayMarket
    //   //   betForm.plyType = '(' + market.betLang + ') ' + this.plyType
    //   // } else if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {
    //   //   betForm.title = this.$store.getters.selectedBettype.sprtTitleLang + ' - ' + this.$store.getters.market.earlyMarket.betLang
    //   // }
    //   // this.$store.commit('BET_FORM', betForm)
    // },
    classNegative (val, oldVal) {
      this.isNegative = parseFloat(val) < 0 ? true : false
    },
    diffOdds (val, oldVal) {
      this.isDiff = parseFloat(val) != parseFloat(oldVal) ? true : false
    },
    diffOddsUpDown (val, oldVal) {
      this.isUp = parseFloat(val) > parseFloat(oldVal) ? true : false
    },
    isDefinedOdds (val) {
      var isDefinedOdds = false
      // if(val.od){
      //   if(typeof val.od[this.plyType] != 'undefined' ) {
      //     if(typeof val.od[this.plyType][this.betType] != 'undefined' ) {
      //       if(typeof val.od[this.plyType][this.betType]['odds'+ this.team] != 'undefined' ) {
      //         isDefinedOdds = true
      //       }
      //     }
      //   }
      // }
      var od = val.od
      var bmk = this.bmk
      var plytyp = this.plytyp
      var bettyp = this.bettyp
      var type = this.type
      var team = this.team
      if(od[team]){
        isDefinedOdds = true
      }
      return isDefinedOdds
    },
    checkOdds() {
      if(this.isAllBet){
        $('.odds.'+this.uid).removeClass('red_text')
        $('.odds.'+this.uid).removeClass('green_text')
        if(this.isDiff){
          if(this.isUp){
            $('.odds.'+this.uid).addClass('red_text')
          }else{
            $('.odds.'+this.uid).addClass('green_text')
          }
        }
      }else{
        $('.odd-value.'+this.uid).removeClass('red')
        $('.odd-value.'+this.uid).removeClass('green')
        $('.odd-column-item.'+this.uid).removeClass('mred')
        $('.odd-column-item.'+this.uid).removeClass('mgreen')
        if(this.isDiff){
          if(this.isUp){
            $('.odd-value.'+this.uid).addClass('red')
            $('.odd-column-item.'+this.uid).addClass('mred')
          }else{
            $('.odd-value.'+this.uid).addClass('green')
            $('.odd-column-item.'+this.uid).addClass('mgreen')
          }
        }
      }
    },
  },
  beforeMount() {
    /*
    EventBus.$on(['refreshOdd'], ((params) => {
      if (params == false) {
        this.refreshOdd = false // change market, change page, change parlayEarlyDate
      } else {
        this.refreshOdd = true // change odd type, refresh button
      }
    }).bind(this))
*/
    EventBus.$on(['diffOdd'], ((params) => {
      if(typeof this.event.all == 'undefined') {
        if(this.isDefinedOdds(this.event) && this.isDefinedOdds(params)) {
          this.diffOdds(params.od[this.plyType][this.betType]['odds'+ this.team], this.event.od[this.plyType][this.betType]['odds'+ this.team])
          this.$forceUpdate()
        }
      }
    }).bind(this));
  },
  beforeDestroy() {
    EventBus.$off('diffOdd');
  },
})



// WEBPACK FOOTER //
// ./resources/score/vue/components/odd1x2.js